import React from "react";
import "../../css/Tools/Tools.css";

const ScholarshipList = () => {
  return (
    <div className="tool-container">
      <div className="tool-content">
        <div className="tool-icon-container">
          <svg
            className="tool-icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>

        <div className="tool-status">
          <svg
            className="tool-status-icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          Coming Soon
        </div>

        <h1 className="tool-title">Scholarship Search</h1>

        <p className="tool-message">
          Our scholarship search tool is currently a work in progress. In the
          meantime, please visit the College Board's Scholarship Search page.
        </p>

        <div className="tool-links">
          <a
            href="https://bigfuture.collegeboard.org/scholarship-search"
            className="tool-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="tool-link-text">
              Go to College Board's Scholarship Search
              <svg
                className="tool-link-icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                />
              </svg>
            </span>
          </a>
        </div>

        <div className="tool-features">
          <h3 className="tool-features-title">What You'll Find</h3>
          <ul className="tool-features-list">
            <li className="tool-feature-item">
              <svg
                className="tool-feature-icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span className="tool-feature-text">
                Thousands of scholarships from various organizations
              </span>
            </li>
            <li className="tool-feature-item">
              <svg
                className="tool-feature-icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span className="tool-feature-text">
                Filter by amount, deadline, and eligibility criteria
              </span>
            </li>
            <li className="tool-feature-item">
              <svg
                className="tool-feature-icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span className="tool-feature-text">
                Personalized recommendations based on your profile
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ScholarshipList;
